import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

interface AdminRouteProps {
  element: JSX.Element
}

const AdminRoute = ({ element }: AdminRouteProps) => {
  const { token, user } = useAuth()

  if (!token || !user) {
    return <Navigate to="/login" />
  }

  if (!['admin', 'super_admin'].includes(user.role)) {
    return <Navigate to="/" />
  }

  return element
}

export default AdminRoute
